export const ROUTES = {
  HOME: "/",
  CLASS_DETAIL: "/class/:classId",
  CLASS_ATTENDANCE: "/class-attendance/:classId",
  STUDENT_ATTENDANCE:
    "/class-attendance/:classId/student-attendance/:studentId",
  TRACKIFY: "/trackify",
  TRACKIFY_CLASS: "/trackify/:classId",
  CALENDFY: "/calendfy",
  LOGIFY: "/logify",
  REPORTIFY: "/reportify",
  REPORTIFY_DETAIL: "/reportify/:id",
  SIGN_UP: "/auth/signup",
  LOG_IN: "/auth/login",
  FORGOT_PASSWORD: "/auth/forgot-password",
  UPDATE_PASSWORD: "/auth/update-password/:token",
  NOTIFY_SETTINGS: "/notify/settings",
  DEMO: "/demo",
  DEMO_STUDENT: "/demo/student/:studentId",
  NOT_FOUND: "*",
};
